import { styled } from '@mui/material/styles';

export default styled('h2')`
    font-size: 15px;
    font-weight: 600;

    ${({ size }) => size === 'sm' && `font-size: 13px;`}
`;
